
import { Options, Vue, prop } from "vue-class-component";

class Props {
  is = prop<string>({
    default: "div",
    type: String,
  });
  childIs = prop<string>({
    default: "div",
    type: String,
  });
  parentId = prop<string>({
    default: "",
    type: String,
    required: true,
  });
  itemHeight = prop<number>({
    default: 85,
    type: Number,
    required: true,
  });
  dataList = prop<any[]>({
    default: [],
    type: Array,
  });
  enableVirtualScroll = prop<boolean>({
    default: false,
    type: Boolean,
  });
}

@Options({
  watch: {
    virtualData() {
      requestAnimationFrame(() => {
        this.calculateParentHeight();
      });
    },
  },
})
export default class VirtualScroll extends Vue.with(Props) {
  scrollY = 0;
  scrollThrottle: any;
  get isVirtualScrollEnabled() {
    return (
      this.enableVirtualScroll &&
      this.parentId &&
      this.itemHeight
    );
  }
  handleParentScroll(e: any) {
    if (!this.isVirtualScrollEnabled) return;
    if (this.scrollThrottle) {
      cancelAnimationFrame(this.scrollThrottle);
    }
    this.scrollThrottle = requestAnimationFrame(() => {
      this.scrollY = Math.max(0, e.target.scrollTop);
    });
  }

  clientHeight = 0;
  calculateParentHeight() {
    if (!this.isVirtualScrollEnabled) return;
    const parentEl = document.getElementById(this.parentId);
    if (parentEl) {
      this.clientHeight = parentEl?.clientHeight || 0;
      return;
    }
    this.clientHeight = this.estimateHeight * 5;
  }

  estimateHeight = this.itemHeight || 0;
  get virtualVisible() {
    return Math.ceil(this.clientHeight / this.estimateHeight) * 2;
  }
  get allItemsLength() {
    return this.dataList.length;
  }
  get virtualStart() {
    return Math.max(
      0,
      Math.ceil(this.scrollY / this.estimateHeight) -
        Math.max(1, Math.ceil(this.virtualVisible / 2))
    );
  }
  get virtualPaddingTop() {
    return this.virtualStart * this.estimateHeight;
  }
  get virtualPaddingBot() {
    return Math.max(
      0,
      this.estimateHeight * (this.dataList.length - this.virtualVisible) -
        this.virtualPaddingTop
    );
  }
  get virtualData() {
    return this.dataList.map((item: any, index) => ({ item, index }));
  }
  get virtualList() {
    if (this.isVirtualScrollEnabled) {
      return this.virtualData.slice(
        this.virtualStart,
        this.virtualStart + this.virtualVisible
      );
    }

    return this.virtualData;
  }

  mounted() {
    this.calculateParentHeight();
    window.addEventListener("resize", this.calculateParentHeight);
  }

  unmounted() {
    window.removeEventListener("resize", this.calculateParentHeight);
  }
}
